"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInformation = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const styles_1 = require("./styles");
const ProductInformation = (props) => {
    const { productInformation, attributes = [] } = props;
    return attributes !== undefined && attributes.length > 0 ? (react_1.default.createElement(styles_1.StyledInformationContainer, { "data-cy": 'product-information' },
        react_1.default.createElement(__1.ProductHeading, { title: productInformation }),
        react_1.default.createElement(styles_1.AttributeTable, { "data-cy": "product-information-table" },
            react_1.default.createElement("tbody", { "data-cy": "product-information-tbody" }, attributes.map((value, index) => {
                return (react_1.default.createElement("tr", { key: index, "data-cy": "product-information-tr" },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(styles_1.StyledSpan, { bold: true, font: "base", color: "secondary", "data-cy": "attribute-label" }, Object.keys(value)[0])),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(styles_1.StyledSpan, { font: "base", color: "secondary", "data-cy": "attribute-value" }, Object.values(value)[0]))));
            }))))) : null;
};
exports.ProductInformation = ProductInformation;
